import { render, staticRenderFns } from "./FixSmsHazards.vue?vue&type=template&id=d8c9e940&scoped=true"
import script from "./FixSmsHazards.vue?vue&type=script&lang=js"
export * from "./FixSmsHazards.vue?vue&type=script&lang=js"
import style0 from "./FixSmsHazards.vue?vue&type=style&index=0&id=d8c9e940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c9e940",
  null
  
)

export default component.exports